import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import noop from 'lodash/noop';
import { Spotlight as AkSpotlight } from '@atlaskit/onboarding';
import { buttonActionTypes } from '../../common/types/button';
import HtmlContent from '../../controllers/utils/html-content';
// eslint-disable-next-line @repo/internal/react/no-class-components
var EngagementSpotlight = /*#__PURE__*/function (_Component) {
  function EngagementSpotlight() {
    _classCallCheck(this, EngagementSpotlight);
    return _callSuper(this, EngagementSpotlight, arguments);
  }
  _inherits(EngagementSpotlight, _Component);
  return _createClass(EngagementSpotlight, [{
    key: "getButtonClickHandler",
    value: function getButtonClickHandler(buttonType, action) {
      var fireClickEvent = this.props.fireClickEvent;
      switch (action.type) {
        case buttonActionTypes.LINK:
          return function () {
            fireClickEvent("".concat(buttonType));
            window.open(action.data.url, action.data.target);
          };
        default:
          return function () {
            fireClickEvent("".concat(buttonType));
          };
      }
    }
  }, {
    key: "getButtonActions",
    value: function getButtonActions() {
      var _this$props = this.props,
        primaryAction = _this$props.primaryAction,
        primaryText = _this$props.primaryText,
        secondaryAction = _this$props.secondaryAction,
        secondaryText = _this$props.secondaryText;
      var actions = [];
      if (secondaryAction && secondaryText) {
        actions.push({
          onClick: this.getButtonClickHandler('secondary', secondaryAction),
          text: secondaryText,
          appearance: secondaryAction.appearance
        });
      }
      if (primaryAction && primaryText) {
        actions.push({
          onClick: this.getButtonClickHandler('primary', primaryAction),
          text: primaryText,
          appearance: primaryAction.appearance,
          autoFocus: true
        });
      }
      return actions;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        body = _this$props2.body,
        dialogPlacement = _this$props2.dialogPlacement,
        dialogWidth = _this$props2.dialogWidth,
        title = _this$props2.title,
        image = _this$props2.image,
        pulse = _this$props2.pulse,
        target = _this$props2.target,
        targetBgColor = _this$props2.targetBgColor,
        targetRadius = _this$props2.targetRadius;
      return /*#__PURE__*/React.createElement(AkSpotlight, {
        actions: this.getButtonActions(),
        dialogPlacement: dialogPlacement,
        dialogWidth: dialogWidth,
        heading: title,
        image: image,
        pulse: pulse,
        target: target,
        targetBgColor: targetBgColor,
        targetRadius: targetRadius
      }, /*#__PURE__*/React.createElement(HtmlContent, {
        html: body
      }));
    }
  }]);
}(Component);
_defineProperty(EngagementSpotlight, "defaultProps", {
  fireClickEvent: noop
});
export { EngagementSpotlight as default };